import React, { FC, ReactNode, useState } from 'react';
import classNames from 'classnames';

import Paragraph from '@sv-support-sdk/ui-components/src/components/Typography/Paragraph';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import css from './style.module.scss';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

interface IProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  icon?: string;
  expanded?: boolean;
  isCollapsable?: boolean;
  isMobile?: boolean;
  arrowType?: 'icon' | 'text';
}

const Collapse: FC<IProps> = ({
  children,
  title,
  subtitle,
  icon,
  expanded,
  arrowType = 'icon',
  isCollapsable = true,
  isMobile,
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const handleExpand = () => setIsExpanded(!isExpanded);

  return (
    <div className={classNames(css.collapse, {
      [css.notCollapsable]: !isCollapsable,
      [css.isMobile]: isMobile,
      [css.isFirst]: expanded,
      [css.withIcon]: arrowType === 'icon',
    })}>
      {icon && !isMobile && (
        <div className={css.collapse__icon} onClick={handleExpand}>
          <Icon id={icon} />
        </div>
      )}
      <div className={css.collapse__content}>
        <div className={css.collapse__contentHeader} onClick={handleExpand}>
          <div className={css.collapse__contentHeaderBody}>
            {icon && isMobile && (
              <div className={css.collapse__icon} onClick={handleExpand}>
                <Icon id={icon} />
              </div>
            )}
            <Headline type="secondary" fontSize="20" lineHeight="32">
              {title}
            </Headline>
            {subtitle && (
              <Paragraph fontSize="16" lineHeight="24">
                {subtitle}
              </Paragraph>
            )}
          </div>
          {isCollapsable && isMobile && (
            <div className={css.collapse__arrow} onClick={handleExpand}>
              {arrowType === 'icon' ? (
                <div className={css.collapse__arrowIcon}>
                  <Icon
                    id={
                      isExpanded ? '24--keyboard-arrow-up-outlined' : '24--keyboard-arrow-down-outlined'
                    }
                  />
                </div>
              ) : (
                <span className={css.collapse__arrowText}>
                  {isExpanded ? 'Show less' : 'Show more'}
                </span>
              )}
            </div>
          )}
        </div>
        {(isExpanded || !isCollapsable) && <div className={css.collapse__body}>{children}</div>}
      </div>
      {isCollapsable && !isMobile && (
        <div className={css.collapse__arrow} onClick={handleExpand}>
          {arrowType === 'icon' ? (
            <div className={css.collapse__arrowIcon}>
              <Icon
                id={
                  isExpanded ? '24--keyboard-arrow-up-outlined' : '24--keyboard-arrow-down-outlined'
                }
              />
            </div>
          ) : (
            <span className={css.collapse__arrowText}>
              {isExpanded ? 'Show less' : 'Show more'}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Collapse;
